import React from 'react';
import PropTypes from 'prop-types';

import WebinarIcon from '../../../common/icons/WebinarIcon';

const WebinarBlockMobile = props => {
  return (
    <div className="m-webinar-block">
      <div className="m-webinar-block-header">
        <div className="is-flex align-items-center">
          <WebinarIcon color="#131925" />
          <p className="ml-10px">Nearest webinar</p>
        </div>
        <p className="m-webinar-block-date mt-5px">{props.webinar.date}</p>
      </div>
      <div className="m-webinar-block-content">
        <p className="m-webinar-block-title">{props.webinar.name}</p>
        <p className="m-webinar-block-text">{props.webinar.description}</p>
        <p className="m-webinar-block-price">{props.webinar.price === 0 ? '---' : props.webinar.price} €</p>
        <button className="gradient-button mt-10px">Participate</button>
      </div>
    </div>
  );
};

WebinarBlockMobile.propTypes = {
  webinar: PropTypes.shape({
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    date: PropTypes.string.isRequired,
  }).isRequired,
};

export default WebinarBlockMobile;
